import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import SplashScreen from './component'
import Overlay from '../../Atoms/Overlay'
import Settings from '../../Organisms/Settings'
import TeamRegister from '../../Organisms/TeamRegister'

import { reRegisterDevice } from '../../../redux/device'
import { getGames } from '../../../redux/game'

class SplashScreenContainer extends PureComponent {
  state = {
    showSplash: true,
    showSettings: false
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.registered && !prevProps.registered) {
      this.closeSettings()
    }

    if (!this.props.registered && prevProps.registered) {
      this.setState({ showSplash: true })
    }

    if (this.props.finishTime === null && prevProps.finishTime !== null) {
      return this.setState({ showSplash: true })
    }

    if (this.props.gameState === 'locked' && prevProps.gameState !== 'locked' && !prevState.showSplash) {
      this.setState({ showSplash: true })
    }

    if (this.props.gameState === 'submitted' && prevProps.gameState !== 'submitted' && !prevState.showSplash) {
      this.setState({ showSplash: true })
    }

    if (this.props.testMode && this.props.registered && this.props.teamRegistered && prevState.showSplash) {
      this.setState({ showSplash: false })
    }
  }

  handleButtonPress = () => {
    this.setState({
      showSplash: !this.state.showSplash
    })
  }

  closeSettings = () => {
    this.setState({
      showSettings: false
    })
  }

  handleSettingsPress = () => {
    this.setState({
      showSettings: true
    })
  }

  handleAttemptReconnect = async (gameId) => {
    await this.props.reRegisterDevice(gameId)
  }

  handleGetGames = () => {
    this.props.getGames(this.props.hostname)
  }

  render () {
    if (!this.state.showSplash) {
      if (!this.props.teamRegistered) {
        return (
          <Overlay>
            <TeamRegister />
          </Overlay>
        )
      }
      return null
    }
    if (this.state.showSettings) {
      return (
        <Overlay>
          <Settings
            closeSettings={this.closeSettings}
          />
        </Overlay>
      )
    }
    const teamName = this.props.teamName ? `${this.props.teamName} Bank` : this.props.teamId ? `Team ${this.props.teamId}` : null
    let hasCustomLogo = this.props.hasCustomLogo && this.props.hasDownloadedCustomLogo
    let customLogoFile = null
    if (hasCustomLogo) {
      customLogoFile = this.props.filesToDownload['logo.png']
    } else if (this.props.participantDetails && this.props.participantDetails.eventLogo) {
      customLogoFile = this.props.participantDetails.eventLogo
      hasCustomLogo = true
    }

    let splashScreenTitle = this.props.splashScreenTitle
    if (!splashScreenTitle) {
      if (this.props.participantDetails && this.props.participantDetails.gameName) {
        splashScreenTitle = this.props.participantDetails.gameName
      }
    }

    return (
      <Overlay>
        <SplashScreen
          onSettingsPress={this.handleSettingsPress}
          onButtonPress={this.handleButtonPress}
          buttonEnabled={this.props.buttonEnabled}
          allowReconnect={this.props.allowReconnect}
          onAttemptReconnect={this.handleAttemptReconnect}
          downloading={this.props.downloading}
          teamName={teamName}
          gameName={this.props.gameName}
          splashScreenTitle={splashScreenTitle}
          hasCustomLogo={hasCustomLogo}
          customLogoFile={customLogoFile}
          registerError={this.props.registerError}
          participantDetails={this.props.participantDetails}
          gameStarted={this.props.gameStarted}
          gameState={this.props.gameState}
          games={this.props.games}
          onFetchGames={this.handleGetGames}
        />
      </Overlay>
    )
  }
}

const mapStateToProps = (state) => {
  const gameEnabled = state.game.state !== 'locked' && (state.game.finishTime !== null || state.game.state === 'wrapup')
  const hostname = state.device.hostname
  return {
    teamName: state.team.name,
    teamId: state.team.id,
    downloading: state.files.downloading && !state.files.downloaded,
    registered: state.device.registered,
    teamRegistered: state.team.registered,
    gameState: state.game.state,
    gameName: state.game.gameName,
    splashScreenTitle: state.game.splashScreenTitle,
    hasCustomLogo: state.game.hasCustomLogo,
    hasDownloadedCustomLogo: state.game.hasDownloadedCustomLogo,
    filesToDownload: state.files.filesToDownload,
    finishTime: state.game.finishTime,
    buttonEnabled: state.files.downloaded && state.device.registered && state.device.connected && gameEnabled,
    allowReconnect: state.device.hasSetupInfo && !state.device.registered,
    registerError: state.device.error,
    testMode: state.game.automate.testModeScreen || state.game.automate.testModeWidgets,
    participantDetails: state.device.participantDetails,
    gameStarted: state.game.currentRound > 0,
    games: state.game.games[hostname],
    hostname
  }
}

export default connect(mapStateToProps, {
  reRegisterDevice,
  getGames
})(SplashScreenContainer)
